// extracted by mini-css-extract-plugin
module.exports = {"scoreSectionStyle":"ZpoqgJP4_n0YutvJB2ApV"};